import { Brain, RefreshCw } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { API_URL, apiFetch } from '../../../config/api';
import NeuralGraph from '../../dashboard/NeuralGraph';

interface GraphStats {
  wiki_count: number;
  memory_count: number;
  inference_count: number;
}

export const FlzNeural: React.FC = () => {
  const [mode, setMode] = useState<'default' | 'twin'>('default');
  const [stats, setStats] = useState<GraphStats | null>(null);
  const [loading, setLoading] = useState(false);

  const loadStats = async () => {
    setLoading(true);
    try {
      const r = await apiFetch(`${API_URL}/api/twin/habitat/neural-graph`);
      const d = await r.json();
      if (d.ok) setStats(d.stats);
    } catch { /* no twin yet */ }
    setLoading(false);
  };

  useEffect(() => { void loadStats(); }, []);

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#000' }}>
      {/* Toolbar */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8, padding: '6px 12px',
        background: 'rgba(0,0,0,0.6)', borderBottom: '1px solid rgba(255,255,255,0.06)',
        flexShrink: 0,
      }}>
        <Brain size={12} color='#a855f7' />
        <span style={{ fontSize: 10, fontWeight: 700, color: '#fff' }}>Neural Graph</span>
        <div style={{ flex: 1 }} />

        {/* Mode toggle */}
        <div style={{ display: 'flex', gap: 2 }}>
          {(['default', 'twin'] as const).map(m => (
            <button key={m} onClick={() => setMode(m)} style={{
              padding: '3px 8px', borderRadius: 4, border: 'none', cursor: 'pointer', fontSize: 9, fontWeight: 700,
              background: mode === m ? 'rgba(168,85,247,0.3)' : 'rgba(255,255,255,0.05)',
              color: mode === m ? '#c084fc' : 'rgba(255,255,255,0.4)',
            }}>
              {m === 'default' ? 'Brain Wiki' : 'Twin Memory'}
            </button>
          ))}
        </div>

        {/* Stats */}
        {stats && (
          <div style={{ display: 'flex', gap: 8 }}>
            <span style={{ fontSize: 8, color: 'rgba(255,255,255,0.3)' }}>
              {stats.wiki_count} wiki · {stats.memory_count} memories · {stats.inference_count} inferences
            </span>
          </div>
        )}

        <button onClick={loadStats} disabled={loading} style={{
          background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)',
          color: 'rgba(255,255,255,0.5)', cursor: 'pointer', width: 24, height: 24,
          borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <RefreshCw size={10} style={loading ? { animation: 'spin 1s linear infinite' } : {}} />
        </button>
      </div>

      {/* Graph */}
      <div style={{ flex: 1, overflow: 'hidden' }}>
        <NeuralGraph mode={mode} fullInterface={true} />
      </div>
    </div>
  );
};
